import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_accessorial_tasks_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workOrderId?: number, orderId?: number, fullTextSearch?: string, shippingContainerId?: number, shipmentId?: number }): 
  Promise<{ result: { Id?: number, Notes?: string, OperationCodeId?: number, OrderId?: number, ProjectId?: number, StatusId?: number, WorkOrderId?: number, OperationCode?: { Name?: string }, AccessorialTaskProperty?: { TaskId?: number, ActualAmount?: number, ActualUom?: number, ConfirmationPromptTriggerId?: number, DivertToProjectId?: number, ExpectedAmount?: number, ExpectedUom?: number }, Status?: { Name?: string }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }[] }> 
  {
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_accessorial_tasks_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { workOrderId?: number, orderId?: number, fullTextSearch?: string, shippingContainerId?: number, shipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Notes?: string, OperationCodeId?: number, OrderId?: number, ProjectId?: number, StatusId?: number, WorkOrderId?: number, OperationCode?: { Name?: string }, AccessorialTaskProperty?: { TaskId?: number, ActualAmount?: number, ActualUom?: number, ConfirmationPromptTriggerId?: number, DivertToProjectId?: number, ExpectedAmount?: number, ExpectedUom?: number }, Status?: { Name?: string }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_accessorial_tasks_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { workOrderId?: number, orderId?: number, fullTextSearch?: string, shippingContainerId?: number, shipmentId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Notes?: string, OperationCodeId?: number, OrderId?: number, ProjectId?: number, StatusId?: number, WorkOrderId?: number, OperationCode?: { Name?: string }, AccessorialTaskProperty?: { TaskId?: number, ActualAmount?: number, ActualUom?: number, ConfirmationPromptTriggerId?: number, DivertToProjectId?: number, ExpectedAmount?: number, ExpectedUom?: number }, Status?: { Name?: string }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_accessorial_tasks_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workOrderId?: number, orderId?: number, fullTextSearch?: string, shippingContainerId?: number, shipmentId?: number    }) {
      return false;
    }
}
